module.exports = __webpack_public_path__ + "static/media/fundo.67f9e8ba.png";